<mui-wizard-stepper *ngIf="!hideWizardStepper" class="mui-wizard_stepper"></mui-wizard-stepper>
<div class="mui-wizard_steps-container" [style.overflow]="animating ? 'hidden' : null">
  <ng-container *ngFor="let step of steps; let i = index">
    <div class="mui-wizard-step"
         role="tabpanel"
         [id]="_getStepContentId(i)"
         [class.mui-wizard-step--current]="step === selected"
         [hidden]="step !== selected"
         [@wizardAnimation]="_getAnimationDirection(i)"
         (@wizardAnimation.start)="onAnimationStart()"
         (@wizardAnimation.done)="onAnimationDone(i)"
         [attr.aria-labelledby]="(step.stepLabel || step.label) ? _getStepContentId(i) + '-title' : null"
         [attr.aria-expanded]="selectedIndex === i">
      <h2 *ngIf="(step.stepLabel || step.label) && !hideInlineTitles"
          [id]="_getStepContentId(i) + '-title'"
          class="mui-wizard-step_title">
        <ng-container [ngTemplateOutlet]="step.stepLabel?.template || defaultStepLabel"
                      [ngTemplateOutletContext]="{ $implicit: step }"></ng-container>
        <ng-template #defaultStepLabel let-step>{{ step.label }}</ng-template>
      </h2>
      <ng-container [ngTemplateOutlet]="step.content"></ng-container>
    </div>
  </ng-container>
</div>
